import { createRouter, createWebHistory } from 'vue-router';
import { API_URL } from '@idem/common/constantes';
import Profile from '@frontend/profile/profile.view.vue';
import Home from '@frontend/views/home.view.vue';
import { actividades } from '@frontend/router/actividades';
import { empresa } from '@frontend/router/empresa';
import { getLoginRedirectTarget } from '@frontend/router/login-redirect';
import AgregarPromocionView from '@frontend/promociones/agregar-promocion.view.vue';
import CanjearCuponView from '@frontend/promociones/canjear-cupon.view.vue';
import MisSeccionesView from '@frontend/secciones/mis-secciones.view.vue';
import TodasLasSeccionesView from '@frontend/secciones/todas-las-secciones.view.vue';

const routes = [
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/',
    redirect: '/actividades',
  },
  {
    path: '/login',
    name: 'Login',
    component: Home,
    beforeEnter(to, from) {
      const redirectTarget = getLoginRedirectTarget(to, from);
      location.href = `${API_URL}/auth/login?redirect=${encodeURIComponent(redirectTarget)}`;
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Home,
    beforeEnter() {
      location.href = `${API_URL}/auth/logout`;
    },
  },
  {
    path: '/promociones/agregar',
    name: 'AgregarPromocion',
    component: AgregarPromocionView,
  },
  {
    path: '/cupon/canjear',
    name: 'CanjearCupon',
    component: CanjearCuponView,
  },
  {
    path: '/secciones',
    name: 'MisSecciones',
    component: MisSeccionesView,
  },
  {
    path: '/secciones/admin',
    name: 'TodasLasSecciones',
    component: TodasLasSeccionesView,
  },
  actividades,
  empresa,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes as any,
});

export default router;
